import React from "react";
import { useNavbarContext } from "hooks/useContextAll";

const Burger = () => {
    const navbarContext = useNavbarContext();

    return (
        <div
            className={`header-burger ${
                navbarContext.navbarToggle ? "active" : ""
            }`}
            onClick={navbarContext.handleNavbarToggle}
        >
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
        </div>
    );
};

export default Burger;
